import { useState } from 'react'
import {
  Toolbar,
  SaveButton,
  List,
  SimpleForm,
  DateInput,
  DateField,
  TextInput,
  Datagrid,
  Edit,
  Create,
  TextField,
  ReferenceField,
  ReferenceInput,
  NumberInput,
  AutocompleteInput,
  NumberField,
  SelectInput,
  BooleanInput,
  required,
  Show,
  SimpleShowLayout,
  Filter,
  SearchInput,
  Button,
  useRefresh,
  useNotify,
  useRecordContext,
  useDataProvider,
  EditButton,
} from 'react-admin'
import { makeStyles } from '@material-ui/core/styles'
import {
  ExtraPagination,
  formatLogo,
  validatePhone,
  formatPhone,
} from './utils'
import StarRatingField from './components/StarRatingField'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormGroup from '@mui/material/FormGroup'
import Switch from '@mui/material/Switch'
import { Box, Dialog, IconButton, Link, Typography } from '@material-ui/core'
import { Delete as DeleteIcon } from '@mui/icons-material'

const useStyles = makeStyles({
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
  },
})

export const CustomToolbar = (props) => (
  <Toolbar {...props} classes={useStyles()}>
    <SaveButton />
  </Toolbar>
)

const PanelShow = (props) => {
  return (
    <Show
      {...props}
      /* disable the app title change when shown */
      title=" "
      actions={<PrestaActionButtons />}
    >
      <SimpleShowLayout>
        <TextField source="text4" label="Contact" />
        <TextField source="rating9" label="Rating Gestion" />
        <TextField source="classement" label="Réactivité" />
        <TextField source="text2" label="Téléphone" />
        <TextField source="mail" label="Mail" />
      </SimpleShowLayout>
    </Show>
  )
}

const PrestaFilter = (props) => (
  <Filter {...props}>
    <SearchInput source="q" alwaysOn />
    <ReferenceInput
      source="sp_cialit_"
      reference="prestas/specialities"
      label="Spécialité"
    >
      <AutocompleteInput
        optionText="name"
        optionValue="name"
        sx={{ width: 300, ' button': { padding: '4px;' } }}
        size="small"
        label="Spécialité"
        matchSuggestion={() => true}
      />
    </ReferenceInput>
  </Filter>
)
const ArchiveButton = ({ ...props }) => {
  const [open, setOpen] = useState(false)
  const record = useRecordContext()
  const refresh = useRefresh()
  const notify = useNotify()
  const dataProvider = useDataProvider()
  if (!record) return null

  const func = () =>
    dataProvider
      .update('prestas', {
        id: record.id,
        data: { archived: true },
      })
      .then((response) => {
        notify('Succès')
        setOpen(false)
        refresh()
      })
      .catch((error) => {
        notify(`${error.message}`, 'warning')
      })
  return (
    <>
      <IconButton
        style={{
          fontSize: '14px',
          borderRadius: '5px',
          padding: '4px 5px',
          marginRight: 10,
        }}
        {...props}
        onClick={() => {
          setOpen(true)
        }}
      >
        <DeleteIcon
          sx={{
            fontSize: '18px',
            marginRight: '8px',
          }}
        />
        Archiver
      </IconButton>
      <Dialog aria-labelledby="simple-dialog-title" open={open}>
        <div style={{ padding: '20px' }}>
          <Typography>Êtes-vous sûr de vouloir archiver ?</Typography>
          <br />
          <Button
            size="small"
            variant="contained"
            color="secondary"
            onClick={() => func()}
            disableElevation
          >
            Archiver
          </Button>
          <Button
            size="small"
            variant="outlined"
            onClick={() => setOpen(false)}
            style={{ marginLeft: '10px' }}
          >
            Annuler
          </Button>
        </div>
      </Dialog>
    </>
  )
}
const PrestaActionButtons = () => {
  return (
    <Box
      sx={{
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'flex-end',
      }}
    >
      <ArchiveButton color="primary" size="small" />
      <EditButton />
    </Box>
  )
}
export const PrestaList = (props) => (
  <List
    {...props}
    bulkActionButtons={false}
    exporter={false}
    pagination={<ExtraPagination />}
    filters={<PrestaFilter />}
    perPage={100}
  >
    <Datagrid expand={<PanelShow />} bulkActionButtons={false}>
      <TextField source="name" label="Nom" />
      <TextField source="text2" label="Mobile" />
      <TextField source="m_tier" label="Corps de métier" />
      <TextField source="sp_cialit_" label="Spécialité(s)" />
      <TextField
        source="urgence___petite_r_paration__"
        label="Urgence ? Petite réparation ?"
      />
      <StarRatingField label="Note" />
    </Datagrid>
  </List>
)

export const PrestaEdit = (props) => {
  return (
    <Edit
      {...props}
      transform={(data) => {
        data.text2 = formatPhone(data.text2)
        return data
      }}
    >
      <SimpleForm toolbar={<CustomToolbar />}>
        <TextField source="name" label="Nom" />
        <TextInput source="mail" label="Email" />
        <TextInput source="text2" label="Mobile" validate={[validatePhone]} />
        <Speciality />
        <NumberInput source="rating9" label="Note /5" />
        <TextInput source="invoice_adresse" label="Adresse" />
        <TextInput source="invoice_cp" label="Code Postal" />
        <TextInput source="invoice_ville" label="Ville" />
        <TextInput source="invoice_siret" label="SIRET" />
        <TextInput source="invoice_tva" label="TVA" />
        <TextInput source="invoice_iban" label="IBAN" />
      </SimpleForm>
    </Edit>
  )
}

const Speciality = () => {
  const [customSpeciality, setCustomSpeciality] = useState(false)

  return (
    <div style={{ display: 'inline-flex' }}>
      {!customSpeciality ? (
        <ReferenceInput
          source="sp_cialit_"
          reference="prestas/specialities"
          label="Spécialités"
        >
          <AutocompleteInput
            optionText="name"
            optionValue="name"
            sx={{ width: 300, ' button': { padding: '4px;' } }}
            size="small"
            label="Spécialité"
            disabled={customSpeciality ? 'disabled' : ''}
            matchSuggestion={() => true}
          />
        </ReferenceInput>
      ) : null}
      <FormGroup style={{ marginLeft: '10px' }}>
        <FormControlLabel
          control={
            <Switch
              checked={customSpeciality}
              onChange={(event) => setCustomSpeciality(event.target.checked)}
            />
          }
          label="Nouvelle specialité"
        />
      </FormGroup>
      {customSpeciality ? (
        <TextInput source="sp_cialit_" label="Spécialité" />
      ) : null}
    </div>
  )
}

export const PrestaCreate = (props) => (
  <Create
    {...props}
    transform={(data) => {
      data.text2 = formatPhone(data.text2)
      return data
    }}
  >
    <SimpleForm toolbar={<CustomToolbar />}>
      <TextInput source="name" label="Nom" />
      <TextInput source="mail" label="Email" />
      <TextInput source="text2" label="Mobile" validate={[validatePhone]} />
      <Speciality />
      <NumberInput source="rating9" label="Note /5" />
      <TextInput source="invoice_adresse" label="Adresse" />
      <TextInput source="invoice_cp" label="Code Postal" />
      <TextInput source="invoice_ville" label="Ville" />
      <TextInput source="invoice_siret" label="SIRET" />
      <TextInput source="invoice_tva" label="TVA" />
      <TextInput source="invoice_iban" label="IBAN" />
    </SimpleForm>
  </Create>
)
